import React, { Component } from 'react';
import VegaChart from '../../common/vega/VegaChart';
import { Grid } from 'semantic-ui-react';
import * as d3 from 'd3';
import Preloader from '../../components/Preloader';
import { bumpchartPublications } from '../../common/vega/VegaSpecifications';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'
import {LANG, LANG_SPECIFICS} from '../../common/constants'

class DataVizPublicationsBumpchart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            areaOptions: []
        }
    }

    async componentDidMount() {
        const data = await d3.json('data/publications_' + LANG + '.json');

        // Vega spec domain colors by LANG
        bumpchartPublications["scales"][4]["domain"] = LANG_SPECIFICS[LANG].BUMPCHART_COLOR_DOMAIN;

        // Vega spec axes titles translation
        bumpchartPublications["axes"][0]["title"] = strings.RICERCA_INNOVAZIONE.CHARTS.BUMPCHART.AXES.HORIZONTAL
        bumpchartPublications["axes"][1]["title"] = strings.RICERCA_INNOVAZIONE.CHARTS.BUMPCHART.AXES.VERTICAL

        // Vega tooltip translation
        bumpchartPublications["marks"][0]["marks"][1]["encode"]["update"]["tooltip"] = {"signal": "{ title: datum.domain, '" + strings.RICERCA_INNOVAZIONE.CHARTS.BUMPCHART.TOOLTIP.YEAR + "': datum.year, '" + strings.RICERCA_INNOVAZIONE.CHARTS.BUMPCHART.TOOLTIP.NUMBER + "' : format(datum.count, '.2s') + ' / ' + format(datum.sum_count, '.3s'), '" + strings.RICERCA_INNOVAZIONE.CHARTS.BUMPCHART.TOOLTIP.PERCENTAGE + "': format(datum.count / datum.sum_count, '.2%')}"}

        this.setState({
            data: data
        })
    }

    
    render() {

        const { data } = this.state;

        if (data.length > 0) {
            return (
                <Grid className="wrapper">
                    <Grid.Row>
                        <Grid.Column>
                            <VegaChart 
                                chartClass={"bumpchart"}
                                padding={{ top: 36, left: 24, right: 0, bottom: 24 }}
                                data={data}
                                spec={bumpchartPublications}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="border-top">
                        <Grid.Column width={16} className="d-flex flex-wrap">
                            <CSVLink data={data} 
                                     className="ui red circular icon button mx-auto"
                                     filename={"evoluzioneAmbitiRicerca.csv"}>
                                        <i aria-hidden="true" className="download icon"></i>
                            </CSVLink>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            )
        } else {
            return <Preloader message={strings.COMMON.LOADING_DATA} />
        }
    }
}

export default DataVizPublicationsBumpchart;